import Chip from "@mui/material/Chip"

const STATUS_CONFIG = {
  approved: { label: "Approved", color: "success" },
  pending: { label: "Pending approval", color: "warning" },
  rejected: { label: "Rejected", color: "error" },
  inactive: { label: "Inactive", color: "default" },
}

export default function InboxTemplateStatusChip({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.approved
  return <Chip size="small" label={config.label} color={config.color} />
}
